import type { TriggerData } from "@qendo/medical/trigger";
import { MedicalType } from "@qendo/medical/types";
import Data from "~/util/data";

export class Trigger extends Data implements TriggerData {
    public readonly type = MedicalType.trigger;

    public constructor(
        public id?: string,
        public description: string | null = null,
        public option_id: string | null = null,
        public photograph_ids: string[] = [],
        public known = false,
    ) {
        super();
    }
}
